import WizardList from "./WizardList";

export default WizardList;